"use client";
// FR-2: transição de rota — slide/fade 240-420ms, compositor-only, respeita reduced-motion via CSS.
export default function Template({ children }: { children: React.ReactNode }) {
  return <div className="rise">{children}</div>;
}
